<div class="admin-api-keys-edit-component scroll-container fullpage">
  <div class="row">
    <div class="col content-col">
      @if (genAiModel) {
        @if (useAdminForm) {
          <div class="d-flex justify-content-end mb-2">
            <a class="btn btn-xs btn-link" (click)="useAdminForm = false">
              <fa-icon [icon]="['fas', 'user-helmet-safety']" class="me-1"></fa-icon><ng-container i18n="@@components.gen_ai_models_edit.edit_as_templated_model">Edit as templated model</ng-container>
            </a>
          </div>
          <admin-gen-ai-models-edit-form [model]="model$ | async" [disabled]="disableForm" (saveForm)="saveGenAiModel($event)" />
        } @else {
          @if (isEngineering) {
            <div class="d-flex justify-content-end mb-2">
              <a class="btn btn-xs btn-link" (click)="useAdminForm = true">
                <fa-icon [icon]="['fas', 'user-helmet-safety']" class="me-1"></fa-icon><ng-container i18n="@@components.gen_ai_models_edit.edit_as_platform_model">Edit as platform model</ng-container>
              </a>
            </div>
          }
          <gen-ai-models-edit-form [model]="model$ | async" [tenantId]="tenant_id" [disabled]="disableForm" (saveForm)="saveGenAiModel($event)" />
        }
      } @else {
        <div class="alert alert-warning" role="alert" i18n="@@components.gen_ai_models_edit.no_gen_ai_model_given_id">No GenAI Model with the given ID</div>
      }
    </div>
  </div>
</div>
